/**
 *
 * Public interface of ClientComponents component
 *
 */

import ClientComponents from './ClientComponents';
export default ClientComponents;
